export const HIDE_RETAKE_SELFIE_DIALOG = 'UserSettings/HIDE_RETAKE_SELFIE_DIALOG';
export const INITIALIZE_SELFIE_UPDATE = 'UserSettings/INITIALIZE_SELFIE_UPDATE';
export const SELFIE_UPDATE_FAILURE = 'UserSettings/SELFIE_UPDATE_FAILURE';
export const SELFIE_UPDATE_SUCCESS = 'UserSettings/SELFIE_UPDATE_SUCCESS';
export const API_KEY_REGENERATE_SUCCESS = 'UserSettings/API_KEY_REGENERATE_SUCCESS';
export const API_KEY_REGENERATE_FAILURE = 'UserSettings/API_KEY_REGENERATE_FAILURE';
